import StrategyCycle from "../../Assets/Images/Ökobilanz_Wertgrafik_cycle.jpg";
import StrategyLinear from "../../Assets/Images/Ökobilanz_Wertgrafik_linear.jpg";
import "./StrategyPage.style.css";

import CycleStrategyMap from "../../Components/CycleStrategyMap/CycleStrategyMap";
import Data from "../../Assets/Content/StrategyData.js";
import { useEffect } from "react";
import ExpandableCard from "../../Components/ExpandableCard/ExpandableCard";

const StrategyPage = (props) => {
  const { content, setContent, economyType, setEconomyType } =
    props.AppStateService;

  const isLinear = economyType === "linear";

  useEffect(() => {
    document.title = "Kreislaufwirtschafts-Guide | Strategy";
  }, []);

  let setFixText = () => {
    if (economyType === "linear") {
      setContent(Data.LinearMain);
    } else {
      setContent(Data.CycleMain);
    }
  };

  let getMap = (economyType) => {
    if (economyType === "linear") {
      return (
        <div id="strategy-map-container">
          <img
            src={StrategyLinear}
            alt=""
            style={{
              maxWidth: "100%",
              height: "auto",
            }}
            onClick={() => {
              let fixText =
                economyType === "linear" ? Data.LinearMain : Data.CycleMain;
              setContent(fixText);
            }}
          />
        </div>
      );
    } else {
      return (
        <div id="strategy-map-container">
          <img
            src={StrategyCycle}
            alt=""
            useMap="#image-map-full"
            style={{
              maxWidth: "100%",
              height: "auto",
            }}
            onClick={() => {
              let fixText =
                economyType === "linear" ? Data.LinearMain : Data.CycleMain;
              setContent(fixText);
            }}
          />
          <CycleStrategyMap
            AppStateService={{
              setContent,
              economyType,
              setFixText,
            }}
          />
        </div>
      );
    }
  };

  return (
    <div className="container mt-4 mb-5">
      <div className="row justify-content-center">
        <div className="col-lg-10">
          <ExpandableCard title="Strategien" initiallyOpen={true}>
            <div className="hover-text mb-3">
              Wechseln Sie zwischen der Ansicht „Kreislaufwirtschaft“ und
              „Linearwirtschaft“ mithilfe des Buttons oben.
              <br />
              Fahren Sie mit der Maus über die Elemente der Grafik, um mehr zu
              erfahren.
            </div>
            {getMap(economyType)}

            <div className="strategy-text-container mt-3">
              <div className="heading">
                {isLinear ? Data.LinearMain.heading : Data.CycleMain.heading}
              </div>
              <p
                dangerouslySetInnerHTML={{
                  __html: (isLinear
                    ? Data.LinearMain.text
                    : Data.CycleMain.text
                  ).replace(/\n/g, "<br />"),
                }}
              />
            </div>
          </ExpandableCard>
        </div>
      </div>
    </div>
  );
};

export default StrategyPage;
